import { MultipleDocumentUploader } from "@/common/components/MultipleDocumentUploader"
import { useFormContext } from "react-hook-form"
import { CompanyBranchValidationSchema } from "../../schemas/createBranch.schema"
import useBlobs from "@/common/hooks/queries/useBlobs"
import { ErrorMessage } from "@/common/components/ErrorMessage"

interface AdditionalDocumentsProps {
  disabled?: boolean
}

export const AdditionalDocuments = ({
  disabled,
}: AdditionalDocumentsProps) => {
  const { control, setError, clearErrors, formState: { errors } } = useFormContext<CompanyBranchValidationSchema>();

  const { mutateAsync: uploadBlob, isPending: uploadBlobIsPending } = useBlobs();

  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-lg">
        Anexos
      </p>
      <MultipleDocumentUploader
        title="Anexe documentos"
        control={control}
        name="additional_documents_attachments_attributes"
        uploadBlob={uploadBlob}
        fieldName="additional_documents_attachments_attributes"
        accept=".pdf"
        containerClassName="flex-row-reverse justify-end"
        disabled={uploadBlobIsPending || disabled}
        setError={(message) => {
          if (message) {
            setError('additional_documents_attachments_attributes', { message });
          } else {
            clearErrors('additional_documents_attachments_attributes');
          }
        }}
      />
      {errors?.additional_documents_attachments_attributes?.message && (
        <ErrorMessage
          name="additional_documents_attachments_attributes"
          message={errors?.additional_documents_attachments_attributes?.message}
        />
      )}
    </div>
  )
}

